import {useAtom} from "jotai";
import {AnswerAtom} from "../atoms";
import React from "react";
import {IconButton, InputAdornment, Slider, Stack, TextField, Typography, Box, ButtonGroup} from "@mui/material";
import {IconChevronDown, IconChevronUp, IconMinus, IconPlus} from "@tabler/icons-react";


const sliderStyle = {
  color: '#60abce', borderRadius: 2,
  height: 12, py: '0 !important',
  justifySelf: 'stretch',
  '& .MuiSlider-thumb': {
    height: 22,
    width: 22,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit',
    },
    '&:before': {
      display: 'none',
    },
  },
  '& .MuiSlider-track': {
    border: 'none',
  },

}

export const SliderQuestion = () => {
  const [answer, setAnswer] = useAtom(AnswerAtom);

  return (
    <>
      <Box sx={{width: {xs: "85%", md: "100%"}, mx: "auto"}}>
        <Slider
          value={answer?.text || answer?.from || 0}
          sx={sliderStyle}
          min={answer?.from ? +answer?.from : 0}
          max={answer?.to ? +answer?.to : 100}
          onChange={(e) => setAnswer(prev => ({...prev, text: +e?.target?.value}))}
          aria-labelledby="input-slider"
        />
        <Stack direction={"row"} gap={1} justifyContent={"space-between"} alignItems={"center"} sx={{pt: 0.5}}>
          <Typography fontSize={"small"}>Min: {answer?.from}</Typography>

          <Typography fontSize={"small"}>Max: {answer?.to}</Typography>
        </Stack>
      </Box>

      <Stack direction={"row"} gap={1} alignItems={"center"}>
        <Box>
          <IconButton
            className={"border-shadow"}
            onClick={() => {
              const minValue = +answer?.from || 0;
              const maxValue = +answer?.to || 100;
              const step = Math.ceil(maxValue / 10);

              setAnswer(prev => ({...prev, text: +prev?.text - step < minValue ? minValue : +answer?.text - step}));
            }}
          >
            <IconMinus size={20}/>
          </IconButton>
        </Box>
        <TextField
          type="number"
          size={"small"}
          value={answer?.text || answer?.from || ""}
          onChange={(e) => setAnswer(prev => ({...prev, text: +e?.target?.value}))}
          sx={{
            minWidth: "100px", width: "120px", maxWidth: "150px",
            '& .MuiInputBase-root': {p: '3px !important'}
          }}
          error={answer?.text < answer?.from || answer?.text > answer?.to}
          helperText={(answer?.text < answer?.from || answer?.text > answer?.to) && "value must be between " + answer?.from + " and " + answer?.to}
          InputProps={{
            min: answer?.from ? +answer?.from : 0,
            max: answer?.to ? +answer?.to : 100,
            sx: {textAlign: "center"}
          }}
        />
        <Box>
          <IconButton
            className={"border-shadow"}
            onClick={() => {
              const maxValue = +answer?.to || 100;
              const step = Math.ceil(maxValue / 10);

              setAnswer(prev => ({...prev, text: +prev?.text + step > maxValue ? maxValue : +answer?.text + step}));
            }}
          >
            <IconPlus size={20}/>
          </IconButton>
        </Box>
      </Stack>
    </>
  )
}